import { createFileRoute } from "@tanstack/react-router";

import { PraxaAgentDetail } from "../components/praxa/PraxaAgentCatalogSurface";

export const Route = createFileRoute("/w/$workspaceId/agents/$agentId")({
  component: PraxaAgentDetailRoute,
});

function PraxaAgentDetailRoute() {
  const { workspaceId, agentId } = Route.useParams();
  return <PraxaAgentDetail agentId={agentId} workspaceId={workspaceId} />;
}
